import { animate, inView, scroll, stagger } from 'motion';

const htmlElement = document.querySelector('html');

const header = document.querySelector('.header');
const greenLogo = document.querySelector('.logo-green');
const greenBurger = document.querySelectorAll('.green-burger');
const greenCart = document.querySelector('.cart-icon-green');
const greenAccount = document.querySelector('.account-green');
const backgroundAccount = document.querySelector('.account-bg');
const listItem = document.querySelectorAll('.list-item');


if (!htmlElement.classList.contains('shopify-design-mode')) {
  inView('.in-view', ({ target }) => {
    animate(target, { opacity: 1 });

    if (target.querySelector('.slide-up')) {
      animate(
        target.querySelectorAll('.slide-up'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.slide-stagger')) {
      animate(
        target.querySelectorAll('.slide-stagger'),
        { opacity: 1, transform: 'none' },
        { delay: stagger(0.3), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }
    if (target.querySelector('.slide-stagger-left')) {
      animate(
        target.querySelectorAll('.slide-stagger-left'),
        { opacity: 1, transform: 'none' },
        { delay: stagger(0.3), duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.slide-in')) {
      animate(
        target.querySelectorAll('.slide-in'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.slide-in-left')) {
      animate(
        target.querySelectorAll('.slide-in-left'),
        { opacity: 1, transform: 'none' },
        { delay: 0, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }

    if (target.querySelector('.fade-in')) {
      animate(
        target.querySelectorAll('.fade-in'),
        { opacity: 1 },
        { delay: 0, duration: 0.9, easing: [0.17, 0.55, 0.55, 1] }
      );
    }
  });
} else {
  htmlElement.classList.add('no-anim');
}

  scroll(
    animate(header, {
      backgroundColor: ['rgba(40, 56, 33, 0)', 'rgba(40, 56, 33, 1)'],
    }),
    {
      offset: ['0px', '200px'],
    }
  );
  if(greenLogo){
    scroll(
        animate(greenLogo, {
            fill: ['#283821', '#fff']
        }),
        {
          offset: ['0px', '200px'],
        }
      );
  }

  if(greenBurger) {
    greenBurger.forEach(icon => {
        scroll(
            animate(icon, {
                background: ['#283821', '#fff']
            }),
            {
              offset: ['0px', '200px'],
            }
          );
    })

  }
  if(greenCart) {
        scroll(
            animate(greenCart, {
                fill: ['#283821', '#fff'],
                stroke: ['#fff', '#283821'],
            }),
            {
              offset: ['0px', '200px'],
            }
          );
  }
  if(greenAccount) {
    console.log('green icon found');
        scroll(
            animate(greenAccount, {
              color: ['#fff', '#283821'],
            }),
            {
              offset: ['0px', '200px'],
            }
          );
  }

  if(backgroundAccount) {
    scroll(
      animate(backgroundAccount, {
        background: ['#283821', '#fff']
      }),
      {
        offset: ['0px', '200px'],
      }
    );
  }


  listItem.forEach((lisItem) => {
    scroll(
      animate(lisItem, {
        paddingTop: ['1.5rem', '0.25rem'],
        paddingBottom: ['1.5rem', '0.25rem'],
      }),
      {
        offset: ['0px', '200px'],
      }
    );
    if(lisItem.classList.contains('list-item-green')){
        scroll(
            animate(lisItem, {
              color:['#283821', '#fff'],
            }),
            {
              offset: ['0px', '200px'],
            }
          );
    }
  });
